import { apiClient } from "shared/api/client";

/**
 * 회원(appUsers) 도메인 API.
 * 프로필 조회(getUserInfo)는 AuthApi, 프로필 수정(UpdateUserInfo/PatchUserInfo)은
 * SettingApi에 있으므로 여기서는 목록/삭제/권한변경만 담당한다.
 */
export const fetchMembers = async () => {
  const response = await apiClient.get("/appUsers");
  return response.data;
};

export const deleteMember = async (id) => {
  await apiClient.delete(`/appUsers/${id}`);
};

// 일반 관리자로 등록할 때는 선택한 소속(department)도 함께 보내
// 백엔드가 Admin 행을 만들 때 "미등록" 대신 이 값을 사용하도록 한다.
export const updateMemberAuth = async (id, auth, department) => {
  await apiClient.patch(`/appUsers/auth/${id}`, { auth, department });
};

// 로그인한 본인의 관리자 권한을 스스로 반납(일반 회원으로 강등)한다.
// 서버가 토큰으로 본인을 식별하므로 id/파라미터가 필요 없다.
export const withdrawMyAdmin = async () => {
  await apiClient.patch("/appUsers/me/auth/withdraw");
};
